import { JSONSchemaType } from 'ajv'

export interface IThemeEditFormData {
  baseLogoFile: string
  whiteLogoFile: string
  blackLogoFile: string
  baseLogo: string
  whiteLogo: string
  blackLogo: string
  primaryColor: string
  secondaryColor: string
  terciaryColor: string
}

const ThemeEditSchema: JSONSchemaType<IThemeEditFormData> = {
  type: 'object',
  properties: {
    baseLogoFile: {
      type: 'string',
    },
    whiteLogoFile: {
      type: 'string',
    },
    blackLogoFile: {
      type: 'string',
    },
    baseLogo: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    whiteLogo: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    blackLogo: {
      type: 'string',
    },
    primaryColor: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    secondaryColor: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
    terciaryColor: {
      type: 'string',
      minLength: 1,
      errorMessage: 'Campo obrigatório',
    },
  },
  required: ['baseLogo', 'whiteLogo', 'primaryColor', 'secondaryColor', 'terciaryColor'],
  additionalProperties: false,
}

export default ThemeEditSchema
